// extracted by mini-css-extract-plugin
export var center = "_58-2";
export var clickableRow = "_58-5";
export var expandedRow = "_58-7";
export var hoverable = "_58-4";
export var left = "_58-1";
export var right = "_58-3";
export var row = "_58-0";
export var selectedRow = "_58-6";
export var summaryRow = "_58-8";